import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Translate, Localize, translate, getLocale } from "react-i18nify";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { setTranslations, setLocale } from "react-i18nify";
//import QRCode from "react-qr-code";
import { QRCode } from "react-qrcode-logo";

import LanguageButtons from "./../Shared/LanguageButtons";

import KioskIDButton from "./../Shared/KioskIDButton";

import { useKioskVerticalStyles } from "./../../../../kioskverticalstyles_2";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";

import PrinterConnectionModal from "./../Shared/PrinterConnectionModal_V";

import {
  Button,
  Grid,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
  OutlinedInput,
  ButtonGroup
} from "@mui/material";

// import Logo from "./../../Components/Logo";
import Logo from "./../../Components/Logo_V";

import { useTheme } from "@mui/material/styles";

import Icon from "@mdi/react";
import { mdiHandHeart } from "@mdi/js";

let env = require("./../../../../env");

export default function VerticalLayout(props) {
  const {
    setKioskkeyFunc,
    nextFunc,
    donationFunc,
    loading,
    errorMessage,
    isNotMobile,
    kioskkey
  } = props;

  const {
    isConnected,
    socketEvents,
    qrCode,
    connect,
    disconnect,
    getSocket,
    sendEvent,
    clearSocketEvents,
    getKioskTheme
  } = useContext(SocketIOContext);

  const theme = useTheme();

  const kioskTheme = getKioskTheme();
  const kioskverticalstyles_2 = useKioskVerticalStyles();

  //Seems that quickStart is using a string rather than boolean
  //const showQuickStart = kioskTheme.quickStart == "true";

  let showQuickStart = kioskTheme?.quickStart;
  let showDonationButton = kioskTheme?.enableCharities;

  //Hack fix for initial veriable is boolean, but refresh is string
  if (showQuickStart == true) {
    showQuickStart = "true";
  }
  if (showDonationButton == true) {
    showDonationButton = "true";
  }

  return (
    <div style={kioskverticalstyles_2.languageselect.flexBackground}>
      {/* //      style={{
        ...kioskverticalstyles_2.languageselect.flexBackground,
        ...{ background: "red" }
      }} */}
      <div style={kioskverticalstyles_2.languageselect.logo}>
        <center>
          <Logo />
          <KioskIDButton />
        </center>
      </div>

      <div class="fontBold" style={kioskverticalstyles_2.languageselect.title}>
        <Translate value="application.theme.languageSelectMainText" />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "column",
          height: "56vh"
        }}
      >
        <div style={kioskverticalstyles_2.languageselect.button}>
          <Button
            variant="outlined"
            fullWidth
            style={kioskverticalstyles_2.languageselect.innerbutton}
            onClick={nextFunc}
          >
            <Translate value="application.theme.languageSelectContinueButton" />
          </Button>
        </div>

        {showQuickStart == "true" && (
          <div style={kioskverticalstyles_2.languageselect.qrdiv}>
            <div style={kioskverticalstyles_2.languageselect.qrelement}>
              <QRCode
                style={{
                  height: "auto",
                  width: "auto",
                  maxWidth: "100%",
                  maxHeight: "100%"
                }}
                size="300"
                //fgColor="#27a737"
                fgColor={kioskverticalstyles_2.quickStartQRCodeColor}
                bgColor={kioskverticalstyles_2.quickStartQRBGColor}
                // logoImage="/img/ca.svg"
                logoImage={
                  env.REACT_APP_API_ENDPOINT +
                  "/kiosk/getImage/QRLogo" +
                  "?t=" +
                  kioskTheme.lastUpdatedImgETag
                }
                qrStyle="dots"
                removeQrCodeBehindLogo="false"
                eyeRadius={{ outer: 5, inner: 1 }}
                logoPadding="3"
                value={
                  env.CAAPP_URL +
                  "/qs/" +
                  qrCode +
                  "?lang=" +
                  getLocale().toLowerCase()
                }
              />
            </div>

            <div style={kioskverticalstyles_2.languageselect.qrtextelement}>
              <div
                class="fontBold"
                style={{
                  fontSize: "2.8vh",
                  textAlign: "center",
                  marginBottom: "2vh"
                }}
              >
                <Translate value="application.theme.quickStartQRHeader" />
              </div>
              <div
                class="fontNormal"
                style={{ fontSize: "1.7vh", textAlign: "center" }}
              >
                <Translate value="application.theme.quickStartQRBody" />
              </div>
            </div>
          </div>
        )}

        {showDonationButton == "true" && (
          // <DonationButtonElement setShowDrawerMenu={clickCharities} />
          <div
            style={kioskverticalstyles_2.languageselect.donatediv}
            onClick={donationFunc}
          >
            <div
              style={kioskverticalstyles_2.languageselect.donationButtonIcon}
            >
              <Icon path={mdiHandHeart} size={"8vh"} />
            </div>

            <div style={kioskverticalstyles_2.languageselect.qrtextelement}>
              <div
                class="fontBold"
                style={{
                  fontSize: "2.8vh",
                  textAlign: "center",
                  marginBottom: "2vh"
                }}
              >
                <Translate value="application.theme.donationHeader" />
              </div>
              <div
                class="fontNormal"
                style={{ fontSize: "1.7vh", textAlign: "center" }}
              >
                <Translate value="application.theme.donationBody" />
              </div>
            </div>
          </div>
        )}

        <div style={kioskverticalstyles_2.languageselect.languagediv}>
          {kioskTheme.bilingual && <LanguageButtons />}
        </div>
      </div>
      <PrinterConnectionModal />
    </div>
  );
}
